import React, {ReactNode} from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {Box, Chip, Colors, Text} from "@bounce/shared/ui";
import {VARIANT_LETTERS} from "./constants";

const READ_ONLY_FIELD_HEIGHT = 36;
const WEIGHT_FIELD_WIDTH = 88;
const LOCK_ICON_SIZE = 16;
const FROM_FEATURE_FLAG_LABEL = "From feature flag";

export const LockIcon = ({color = Colors.grey._500}: {color?: string}) => (
  <LockOutlinedIcon sx={{fontSize: LOCK_ICON_SIZE, color}} />
);

const fromFeatureFlagChipSx = {
  background: Colors.tertiary._200,
  border: `1px solid ${Colors.tertiary._300}`,
  "& .MuiChip-label .Text": {color: Colors.tertiary._800},
};

export const FromFeatureFlagChip = () => (
  <Chip
    size_="small"
    variant_="inherit"
    icon={<LockIcon color={Colors.tertiary._700} />}
    label={FROM_FEATURE_FLAG_LABEL}
    sx={fromFeatureFlagChipSx}
  />
);

const ReadOnlyField = ({children, width}: {children: ReactNode; width?: number}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      width,
      height: READ_ONLY_FIELD_HEIGHT,
      px: 1.5,
      borderRadius: "8px",
      border: `1px solid ${Colors.tertiary._300}`,
      backgroundColor: Colors.grey._100,
      fontFamily: "monospace",
      fontSize: 13,
    }}
  >
    {children}
  </Box>
);

export const VariantCardHeader = ({index, name, weight}: {index: number; name: string; weight: number}) => (
  <Box sx={{display: "flex", alignItems: "center", gap: 1.5}}>
    <Chip size_="small" variant_="blue" label={VARIANT_LETTERS[index] ?? name} />
    <Box sx={{flex: 1}}>
      <ReadOnlyField>
        {name}
        <LockIcon />
      </ReadOnlyField>
    </Box>
    <Text size={12} sx={{color: Colors.grey._700}}>
      Weight
    </Text>
    <ReadOnlyField width={WEIGHT_FIELD_WIDTH}>
      {`${weight}%`}
      <LockIcon />
    </ReadOnlyField>
  </Box>
);
